import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";

export default function EmailVerificationStatus() {
  const navigate = useNavigate();
  const { state } = useLocation(); // Get data from navigate()

  const email = state; // Your email comes here
  const backendApi = import.meta.env.VITE_URL;

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [btnDisable, setBtnDisable] = useState(false);

  // Handle OTP box input
  const handleInput = (value, index) => {
    if (!/^[0-9A-Za-z]?$/.test(value)) return; // restrict to alphanumeric

    const newOtp = [...otp];
    newOtp[index] = value.toUpperCase();
    setOtp(newOtp);

    // Auto move to next
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // Verify OTP
  // const verifyOtp = async () => {
  //   setBtnDisable(true);
  //   const code = otp.join("");

  //   if (code.length !== 6) {
  //     window.alert.error("Enter full 6-digit OTP");
  //     return;
  //   }

  //   try {
  //     const res = await axios.post(`${backendApi}/api/auth/verify-otp`, {
  //       email,
  //       otp: code,
  //     });

  //     console.log(res);

  //     if (res.data.success) {
  //       window?.alert?.success("Email Verified Successfully!", {
  //         position: "top-center",
  //       });

  //       // navigate("/login");

  //       // setTimeout(() => navigate("/login"), 200);
  //     } else {
  //       window.alert.error(res.data.message || "Invalid OTP");
  //     }
  //   } catch (error) {
  //     window.alert.error("Verification failed");
  //     console.error(error);
  //   } finally {
  //     setBtnDisable(false);
  //   }
  // };

  // import toast from "react-hot-toast"; // or your toast library

  const verifyOtp = async () => {
    setBtnDisable(true);
    const code = otp.join("");

    if (code.length !== 6) {
      toast.error("Enter full 6-digit OTP"); // Use toast directly
      setBtnDisable(false);
      return;
    }

    try {
      const res = await axios.post(`${backendApi}/api/auth/verify-otp`, {
        email,
        otp: code,
      });

      if (res.data.success) {
        toast.success("Email Verified Successfully!", {
          position: "top-center",
        });

        // Redirect after success
        setTimeout(() => navigate("/login"), 1500);
      } else {
        toast.error(res.data.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Verification failed");
      console.error(error);
    } finally {
      setBtnDisable(false);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center px-4">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">
        Verify Your Email
      </h2>

      <p className="text-gray-600 text-center max-w-md mb-4">
        We have sent a 6-digit verification code to:
        <br />
        <span className="font-medium text-gray-900">{email}</span>
      </p>

      {/* OTP input boxes */}
      <div className="flex gap-3 my-4">
        {otp.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            maxLength={1}
            value={digit}
            onChange={(e) => handleInput(e.target.value, index)}
            className="w-12 h-12 text-center border-2 border-gray-400 rounded-lg text-xl font-bold focus:outline-none focus:border-blue-600"
          />
        ))}
      </div>

      <button
        onClick={verifyOtp}
        className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg text-lg font-semibold hover:bg-blue-700 transition"
        disabled={btnDisable}
      >
        {btnDisable ? "Verify..." : "Verify"}
      </button>

      <p className="mt-4 text-sm text-gray-500">
        Didn’t receive the code?{" "}
        <span className="text-blue-600 cursor-pointer">Resend</span>
      </p>
    </div>
  );
}
